import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import useQuery from '../../custom-hooks/useQuery';
import Approveimg from '../../assets/images/Approvd.png' 
import Deniedimg from '../../assets/images/Denied.png' 
import { ApproveRecording } from '../../services/attendance-change';

export const ThankyouPageForRecordingRequest = () => {
  const [message, setMessage] = useState('');
  const [success,setsucess] = useState(false);
  let { id } = useParams();
  let query = useQuery();
  var viewValue = query.get("case");
  
  let userId, isApprove;
  
  if (viewValue) {
    userId = viewValue.split('?').find(part => part.startsWith('userId=')).split('=')[1];
    isApprove = viewValue.split('?').find(part => part.startsWith('Approve=')).split('=')[1];
    viewValue = viewValue.split('?')[0];
  }

  const SubmitApproval = async () => {
    const data = {
      id: Number(id),
      isApprove: isApprove,
      userId: userId
    };
    
    try {
      const response = await ApproveRecording(data);
      if (response.status === 200) {
        if(isApprove === 'true'){
        setMessage("Recording Approved successfully");
        }
        else{
          setMessage("Recording Denied successfully");
        }
        setsucess(true);
      } else {
        setMessage("Recording is not submitted");
      }
    } catch (error) {
      setMessage("An error occurred while submitting Recording");
      setsucess(false);
    }
  }

  useEffect(() => {
    if (userId && isApprove) {
      SubmitApproval();
    }
  }, []);  
  
  return (
    <>
      {success && (
        isApprove === 'true' ? (
          <img src={Approveimg} alt="ss_white_img" height="100%" width="100%" />
        ) : (
          <img src={Deniedimg} alt="ss_white_img" height="100%" width="100%" />
        )
      )}
    </>
  );
}
